import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class NavConfig extends BaseOption {
  static label = "Navigation Items";
  orientation = "vertical";

  useInspectorLabel = false;
  static userInterfaceComponent = {
    component: inspectorTools.NAVIGATION_CONFIGURATION,
  };

  static defaultValue = "";
}
